import React from 'react';
import { useMediaQueries } from "../../../utils/mediaQueries";
import { IconButton } from '../../button';
import {
  ModalWrapper,
  ModalPreview,
  ModalPreviewContent,
  ModalPreviewHeader, 
  ModalPreviewWrapper, 
  ModalPreviewContentSignature,
  BoldLabel
} from './Modals.styled';

const HtmlPreviewModal = ({ isOpen, onClose, children, dataTestId }) => {
  const { isMobile, isTablet, isDesktop } = useMediaQueries();

  if (!isOpen) return null;

  const mediaProps = {
    isMobile,
    isTablet,
    isDesktop
  };

  return (
    <ModalWrapper data-testid="html-preview-modal" isOpen={isOpen}>
      <ModalPreview 
        data-testid="modal-preview"
        {...mediaProps}
      >
        <ModalPreviewWrapper 
          data-testid="modal-preview-wrapper"
          {...mediaProps}
        >
        <ModalPreviewHeader data-testid="modal-preview-header">
          <BoldLabel>Preview</BoldLabel>
          <IconButton 
            icon="close" 
            width="16px" 
            height="16px" 
            onClick={onClose} 
            dataTestId="modal-close-button"/>
        </ModalPreviewHeader>
          <ModalPreviewContent 
            data-testid="modal-preview-content"
            {...mediaProps}
          >
            <ModalPreviewContentSignature 
              data-testid="modal-preview-content-signature"
              {...mediaProps}
            >
              {children}
            </ModalPreviewContentSignature>
          </ModalPreviewContent>
        </ModalPreviewWrapper>
      </ModalPreview>
    </ModalWrapper>
  );
};

export default HtmlPreviewModal;